import { Grid, CircularProgress, Typography } from '@mui/material';
import { CompanyFilter } from './companyTypes';
import {
  DataGrid,
  GridCellValue,
  GridColDef,
  GridRowParams,
  GridSelectionModel,
} from '@mui/x-data-grid';
import { filterCompany } from './companyUtils';
import { Item } from '../../utils/sharedTypes';
import { useFindAllCompaniesQuery } from '../../api/api-hooks';
import { useGridSort } from '../../hooks/useGridSort';
import { useHistory } from 'react-router';
import React from 'react';

interface Props {
  setSelectedCompanies: React.Dispatch<React.SetStateAction<Item[]>>;
  filters: CompanyFilter;
}

const CompaniesTable = ({ setSelectedCompanies, filters }: Props) => {
  const { data: companies } = useFindAllCompaniesQuery({});
  const { push } = useHistory();
  const { sortModel, handleSortModelChange } = useGridSort(
    'companyName',
    'asc'
  );
  if (companies === undefined) return <CircularProgress></CircularProgress>;
  // Define data for display in DataGrid
  const columns: GridColDef[] = [
    { field: 'companyName', headerName: 'Company', width: 200 },
    {
      field: 'departments',
      headerName: 'Departments',
      flex: 1,
      renderCell: (params) => {
        const companyId: GridCellValue = params.getValue(params.id, 'id');
        const company = companies.find((company) => company.id === companyId);
        return (
          <Grid container alignItems='center' direction='row' wrap={'nowrap'}>
            <Typography sx={{ pl: '1rem' }} variant='body2'>
              {company?.departments
                .reduce(
                  (acc, cur) => acc + ', ' + cur.departmentName.trim(),
                  ''
                )
                .slice(2)}
            </Typography>
          </Grid>
        );
      },
    },
  ];
  const rows = companies
    .filter((item) => filterCompany(item, filters))
    .map((item) => ({
      ...item,
      name: item.companyName,
    }));
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedCompanies(
      companies.filter((company) => model.includes(company.id))
    );
  };
  const handleRowClick = (event: GridRowParams) => {
    const companyId = event.row.id;
    push('/companies/details/' + companyId);
  };

  return (
    <div style={{ paddingBottom: '1rem', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={100}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
        disableColumnMenu={true}
        onSelectionModelChange={handleTableSelection}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default CompaniesTable;
